export const GST_FREE = "GST_FREE";
export const GST_INCLUSIVE = "GST_INCLUSIVE";
export const GST_EXCLUSIVE = "GST_EXCLUSIVE";
